import React from "react";
import { v4 as uuidv4 } from "uuid";

import Intercom from "react-intercom";
import { connect } from "react-redux";
import { useQueryParams, withDefault, StringParam } from "use-query-params";

const { REACT_APP_CHAT_SUPPORT_AVAILABLE } = process.env;

const View = ({ user }) => {
  const [{ pdf }] = useQueryParams({ pdf: withDefault(StringParam, null) });
  if (!REACT_APP_CHAT_SUPPORT_AVAILABLE || REACT_APP_CHAT_SUPPORT_AVAILABLE === "false" || pdf) {
    return null;
  }
  return <Intercom appID="tbu8jpls" {...user} />;
};

const mapStateToProps = (state) => {
  const loginedInfo = state.user || {};
  let { user } = loginedInfo;
  if (!user || !user.id || !user.email) {
    const user_id = uuidv4();
    user = {
      user_id,
      email: `guest_${user_id}`,
      name: `guest_${user_id}`,
    };
  } else {
    user = {
      user_id: user.id,
      name: `${user.first_name} ${user.last_name}`,
      email: user.email,
      created_at: new Date(user.created_at).getTime(),
    };
  }
  return { user };
};

export const IntercomChat = connect(mapStateToProps)(View);
